<template>
    <div>
        <el-dialog
            title="ยืนยัน Notify"
            :visible.sync="dialogVisible"
            width="30%"
            :close-on-click-escape="false"
            :close-on-click-modal="false"
             @closed="onHidden"
            :before-close="onHidden"
            custom-class="loadindNotifyConfirm"
            center>
            <p>ชื่อร้าน : {{detail.label}}</p>
            <p>Shop Id : {{detail.id}}</p>
            <p>Shop Code : {{detail.shopCode}}</p>
            <p>address : {{detail.address}}</p>
            <p>province : {{detail.province}}</p>
            <p>district : {{detail.district}}</p>
            <p>subDistrict : {{detail.subDistrict}}</p>
            <p>zipcode : {{detail.zipcode}}</p>
            <p><el-input placeholder="จำนวนออเดอร์" v-model="countOrder"></el-input></p>
            <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 6}"
                placeholder="หมายเหตุ"
                v-model="remark" ></el-input>
             <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">ยกเลิก</el-button>
                <el-button type="primary" @click="createNotify" >ยืนยัน</el-button>
            </span>
            </el-dialog>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'NotifyConfirm',
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        },
        notifyDetail: {
            type: Object,
            default: null
        }

    },
    data () {
        return {
            dialogVisible: false,
            countOrder: null,
            detail: {},
            remark: ''
        }
    },
    watch: {
        dialogShow (val) {
            if (val) {
                this.dialogVisible = true
            }
        },
        notifyDetail (val) {
            if (val) {
                this.countOrder = null
                this.remark = ''
                this.detail = { ...val }
                console.log(this.detail)
            }
        }
    },
    methods: {
        onHidden (done) {
            this.$emit('closeModal')
            if (done !== undefined) {
                done()
            }
        },
        async createNotify () {
            if (this.countOrder === null) {
                this.$message({ type: 'warning', message: 'กรุณากรอกจำนวนออเดอร์ที่จะ notify !' })
                return
            }
            let loadingAddUser = this.$loading({
                target: '.loadindNotifyConfirm',
                text: 'กำลังบันทึก...'
            })
            try {
                let resShop = await fgApi.shop.getShopByShopID({ shop_id: parseInt(this.detail.id) })
                console.log(resShop)
                let resCourier = await fgApi.courier.getCourierByUserID({ target_user_id: resShop.data.userId })
                console.log(resCourier)
                let flashAccID = resCourier.data.courierAccounts.filter(courier => courier.courierId === 4)
                if (flashAccID.length === 0) {
                    this.$message.error('ไม่สามารถ notify ได้ ไม่มีข้อมูล courier FLASH !')
                } else {
                    console.log(this.remark.lenght)
                    if (!this.remark) {
                        this.remark = '-'
                    }
                    let param = {
                        shopId: this.detail.id,
                        courierAccountId: flashAccID[0].courierAccountId,
                        parcelNumber: this.countOrder,
                        remark: this.remark
                    }
                    console.log(param)
                    let resNotify = await fgApi.courier.notifyCourier(param)
                    if (resNotify.success) {
                        this.$message({ type: 'success', message: 'บันทึกข้อมูลเรียบร้อยแล้ว' })
                        this.dialogVisible = false
                        this.$emit('closeModal')
                        this.$emit('closeModalRefresh')
                    } else {
                        this.$message.error(resNotify.message)
                    }
                }
            } catch (error) {
                console.log(error)
                this.$message.error('Oops !, Api is error.')
            }
            loadingAddUser.close()
        }

    }
}
</script>

<style lang="scss" scoped>

</style>
